import { ScoreIntentClassStyleType } from './scoreIntentClassStyleType';

export const getComparedToClassStyle = (delta?: number): 'success' | 'warning' | 'danger' | 'default' => {
    if (delta === undefined) {
        return ScoreIntentClassStyleType.default;
    }
    if (delta >= 0) {
        return ScoreIntentClassStyleType.success;
    } else {
        return ScoreIntentClassStyleType.danger;
    }
};

export const getComparedToAverageClassStyle = (delta?: number): 'success' | 'warning' | 'danger' | 'default' => {
    if (delta === undefined) {
        return ScoreIntentClassStyleType.default;
    }
    if (delta > 2) {
        return ScoreIntentClassStyleType.success;
    }
    if (delta < -2) {
        return ScoreIntentClassStyleType.danger;
    }
    return ScoreIntentClassStyleType.warning;
};

export const getScoreDisplayClassStyle = (delta: number): 'success' | 'warning' | 'danger' => {
    if (delta > 2) {
        return ScoreIntentClassStyleType.success;
    }
    if (delta < -2) {
        return ScoreIntentClassStyleType.danger;
    }
    return ScoreIntentClassStyleType.warning;
};

export const getRankDisplayClassStyle = (delta?: number): 'success' | 'warning' | 'danger' | 'default' => {
    if (delta === undefined) {
        return ScoreIntentClassStyleType.default;
    }
    if (delta >= 2) {
        return ScoreIntentClassStyleType.danger;
    }
    if (delta <= -2) {
        return ScoreIntentClassStyleType.success;
    }
    return ScoreIntentClassStyleType.warning;
};

export const getScoreDisplayClassStyleWithUndefined = (delta: number | undefined): 'success' | 'warning' | 'danger' | undefined => {
    if (delta === undefined) {
        return undefined;
    }
    return getScoreDisplayClassStyle(delta);
};
